module.exports = __webpack_public_path__ + "media/images/categories/carousel/countries-and-cultures-31ce8b4a4a943ec82812e636cbc0b6ef.jpg";